import VoiceDatabase from '@/components/TextPages/VoiceDatabase.vue';
// import VoiceDatabaseDemo1 from '@/components/TextPages/VoiceDatabaseDemo1.vue';
// import VoiceDatabaseDemo2 from '@/components/TextPages/VoiceDatabaseDemo2.vue';
// import MusicDatabaseApp from '@/components/TextPages/MusicDatabaseApp.vue';
import MusicDatabaseTutorial from '@/components/TextPages/MusicDatabaseTutorial.vue';
import MusicDatabase from '@/components/TextPages/MusicDatabase.vue';
import About from '@/components/TextPages/About.vue';
import Home from '@/components/Home/Home.vue';

export default [
    {
        name: 'home',
        path: '/',
        component: Home,
        meta: { public: true, scene: 'list', content: null },
        children: [
            {
                name: 'voice-database',
                path: 'voice-database',
                component: VoiceDatabase,
                meta: { public: true, closeButtonBackLink: '/', scene: 'detail', content: 'voice', order: 0 },
            },
            {
                name: 'music-zone',
                path: 'music-zone',
                component: MusicDatabase,
                meta: { public: true, closeButtonBackLink: '/', scene: 'detail', content: 'music', order: 1 },
            },
            {
                name: 'about',
                path: 'about',
                component: About,
                meta: { public: true, closeButtonBackLink: '/', scene: 'detail', content: 'about', order: 2 },
            },
        ],
    },
];
